/**
 * Handles getting the text node from the provided element and checking if translations exists.
 *
 * @param {HTMLElement} element The element to check and translate for.
 * @param {{translations: {string: string}}} translationObject The translationObject is an object to use for translations.
 */
export function translateText(element, translationObject) {
  if (!element || !translationObject.translations) return;
  const { translations } = translationObject;

  // This only gets the text nodes from the list of childNodes.
  let textNode = Array.from(element.childNodes).filter((n) => {
    return n.nodeType === Node.TEXT_NODE && n.nodeValue && n.nodeValue.trim();
  });
  if (textNode.length > 0) textNode = textNode[0];
  else return;

  // Gets the current text and does some cleanup, checks if there exists a translation for the provided value.
  let currentText = textNode.nodeValue;
  currentText = currentText.replace("+", "").trim();
  if (translations[currentText] === undefined) return;
  textNode.nodeValue = translations[currentText];
}
